import type { Routes } from '@angular/router';
import { authGuard, guestGuard } from '@soft2code/nexpo-lib/core';
import { activeEventGuard } from './core/workspace/active-event.guard';

/**
 * Entrar e escolher a feira ficam **fora** da moldura: quem ainda não escolheu
 * a feira não pode ver um cabeçalho que promete uma. Mostrar o estande ao
 * cliente também fica fora — é tela cheia, para virar o celular.
 *
 * Fora do v1, preservado na branch `parking/expositor-v2`: documentos com
 * assinatura, plano e assinatura, push.
 */
export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'performance' },
	{
		path: 'sign-in',
		canActivate: [guestGuard],
		loadComponent: () => import('./features/account/sign-in-page/sign-in-page').then((m) => m.SignInPage),
	},
	{
		path: 'fairs',
		canActivate: [authGuard],
		loadComponent: () => import('./features/account/fairs-page/fairs-page').then((m) => m.FairsPage),
	},
	{
		path: 'booth',
		canActivate: [authGuard, activeEventGuard],
		loadComponent: () => import('./features/booth/booth-show/booth-show').then((m) => m.BoothShow),
	},
	{
		path: '',
		canActivate: [authGuard, activeEventGuard],
		loadComponent: () => import('./layout/expositor-shell/expositor-shell').then((m) => m.ExpositorShell),
		children: [
			{
				path: 'performance',
				loadChildren: () => import('./features/performance/performance.routes').then((m) => m.PERFORMANCE_ROUTES),
			},
			{
				path: 'showcase',
				loadChildren: () => import('./features/showcase/showcase.routes').then((m) => m.SHOWCASE_ROUTES),
			},
			{
				path: 'catalog',
				loadChildren: () => import('./features/catalog/catalog.routes').then((m) => m.CATALOG_ROUTES),
			},
			{
				path: 'contacts',
				loadChildren: () => import('./features/contacts/contacts.routes').then((m) => m.CONTACTS_ROUTES),
			},
			{ path: 'help', loadChildren: () => import('./features/help/help.routes').then((m) => m.HELP_ROUTES) },
		],
	},
	{ path: '**', redirectTo: 'performance' },
];
